/**
 * Step 10 — Key People
 *
 * Focuses solely on the Key People tab from Project Settings.
 * Configure accountability roles shown on every project.
 */

import { StepWrapper } from '../StepWrapper';
import SettingsProject from '@/pages/settings-project';

interface StepProps {
  onNext: () => void;
  onBack: () => void;
  onSkip: () => void;
  isLastStep: boolean;
}

export function Step10KeyPeople({ onNext, onBack, onSkip, isLastStep }: StepProps) {
  return (
    <StepWrapper
      barState="default"
      barMessage="Define which accountability roles appear on projects and whether they are required at creation time."
      showBack={true}
      showSkip={true}
      nextLabel={isLastStep ? 'Finish Setup →' : 'Next Step →'}
      onNext={onNext}
      onBack={onBack}
      onSkip={onSkip}
    >
      <div className="mb-4">
        <h2 className="text-lg font-semibold text-foreground">Key People</h2>
        <p className="text-sm text-muted-foreground mt-0.5">
          Configure which roles (Project Manager, Director, etc.) are visible and required across all projects.
        </p>
      </div>
      <div className="rounded-lg border border-border overflow-hidden bg-background shadow-sm">
        <SettingsProject defaultTab="key-people" />
      </div>
    </StepWrapper>
  );
}
